<template>
    <div class="page-container">
        <div class="page-top">
            <!-- 输入任意文本 -->
            <van-field v-model="name" :border='false' label="联系人" placeholder="请填写联系人姓名" />
            <!-- 输入手机号，调起手机号键盘 -->
            <van-field v-model="tel" type="tel" maxlength="11" :border='false' label="手机号" placeholder="请填写手机号"/>
            <van-field v-model="area" :disabled="true" class="hasarea" v-if="area" @click="showArea = true" :border='false' label="地区" placeholder="请选择省/市/区" />
            <van-field v-model="area" :disabled="true" v-else :border='false' @click="showArea = true" label="地区" placeholder="请选择省/市/区" />
            <van-field
            v-model="detail"
            rows="3"
            autosize
            :border='false'
            label="详细地址"
            type="textarea"
            placeholder="街道、楼牌号等"
            class="addrtextarea"
            style="border-bottom: none;"
            />
            <div class="btn-clear">
                <span @click="detail=''">清空</span>
            </div>
        </div>
        <div class="page-bottom">
            <van-field
            v-model="copyedaddress"
            rows="3"
            autosize
            :border='false'
            type="textarea"
            placeholder="粘贴地址信息，自动识别姓名、电话和地址 例：御先生，1800000000，北京市海淀区某某某小区234号楼483单元"
            class="addrtextarea"
            style="border-bottom: none;height:120px;"
            @input="copyAddr"
            />
        </div>
        

        <div class="btn-confirm" @click="confirm">{{id ? '保存修改' : '新增客户'}}</div>
        <!-- 省市区 -->
        <van-area :hidden="!showArea" @cancel="showArea = false" @confirm="confirmArea" :value="areaCode" title="请选择省市区" :area-list="areaList" />
    </div>
</template>

<script>
import { Field,Area,Toast } from 'vant'
import areaList from '../../lib/area'

import $http from '@/lib/request'
import config from '@/config'
import {checkPhoneValue}from '@/lib/util'
import AddressParse from 'address-parse'

export default {
    data(){
        return {
            name:'',
            tel:'',
            area:'',
            detail:'',//详细地址
            showArea:false,
            areaList:areaList,
            province:'',//省
            city:'',//市
            county:'',//区
            remark:'',//备注
            id:'',//地址id
            copyedaddress:'',
            areaCode:'110101',//省市区编码
        }
    },
    components:{
        [Field.name]:Field,
        [Area.name]:Area,
        [Toast.name]:Toast
    },
    activated(){
        if(this.$route.params.id){
            this.id=this.$route.params.id;
            document.title='编辑地址';
            this.$store.commit('setNextTitle','编辑地址');
            $http({
                method:'post',
                data:{
                    id:this.id
                },
                url:config.api.getAddDetail
            }).then(res=>{
                if(res.errno == 0){
                    let addressInfo=res.data;

                    this.name=addressInfo.name;
                    this.tel=addressInfo.mobile;
                    this.area=`${addressInfo.province}/${addressInfo.city}/${addressInfo.county}`
                    this.detail=addressInfo.address;
                    this.province=addressInfo.province;
                    this.city=addressInfo.city;
                    this.county=addressInfo.county;
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    },
    deactivated(){
        this.name='';
        this.tel='';
        this.area='';
        this.detail='';//详细地址
        this.showArea=false;
        this.areaList=areaList;
        this.province='';//省
        this.city='';//市
        this.county='';//区
        this.remark='';//备注
        this.id='';
    },
    methods:{
        copyAddr(value){
            this.copyedaddress=value;
            let result=AddressParse.parse(value);
            result=result[0];
            this.name=result.name;
            this.tel=result.mobile;
            this.area=`${result.province}/${result.city}/${result.area}`;
            this.detail=result.details;//详细地址
            this.province=result.province;//省
            this.city=result.city;//市
            this.county=result.area;//区
            this.areaCode=result.code;
        },
        confirmArea(result){
            let areastr=result[0].name + '/' + result[1].name + '/' + result[2].name;
            this.area=areastr;

            this.province=result[0].name;
            this.city=result[1].name;
            this.county=result[2].name;

            this.showArea=false;
        },
        confirm(){
            if(!checkPhoneValue(this.tel)){
                Toast('请输入正确的手机号');
                return;
            }
            if(!this.name){
                Toast('请输入姓名');
                return;
            }
            if(!this.province){
                Toast('请选择地区');
                return;
            }
            if(!this.detail){
                Toast('请输入详细地址');
                return;
            }
            $http({
                method:'post',
                data:{
                    name:this.name,
                    mobile:this.tel,
                    province:this.province,
                    city:this.city,
                    county:this.county,
                    address:this.detail,
                    reamrk:this.remark,
                    id:this.id
                },
                url:config.api.addressAdd
            }).then(res=>{
                if(res.errno == 0){
                    Toast('保存成功');
                    this.$router.go(-1);
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .van-field--disabled .van-field__label{
    color:#646566!important;
}
::v-deep .van-field__control:disabled {
    color: #999;
    cursor: not-allowed;
    opacity: 1;
    -webkit-text-fill-color: #999;
}
::v-deep .van-picker{
    box-shadow: 0 -1px 5px 0 #eee;
    position:fixed;
    left:0;
    bottom:0;
    width:100vw;
    z-index: 9;
}
::v-deep .hasarea .van-field__control:disabled{
    color:#333;
    -webkit-text-fill-color:#323233;
}
::v-deep ::-webkit-input-placeholder {
  color: #999;
}
::v-deep :-moz-placeholder {/* Firefox 18- */
  color: #999;
}
::v-deep ::-moz-placeholder{/* Firefox 19+ */
 color: #999;
}
::v-deep :-ms-input-placeholder {
  color: #999;
}
.page-container{
    min-height:100vh;
    box-sizing: border-box;
    background:#fafafa;
    padding:10px;
    .page-top{
        background:#fff;
        border-radius: 4px;
        padding:0 15px;
        padding-top:5px;
        .van-cell{
            border-bottom: 1px solid #f5f5f5;
            padding:15px 0;
        }
        .addrtextarea{
            height:120px;
        }
        .btn-clear{
            text-align: right;
            font-size: 12px;
            color:#999;
            line-height: 17px;
            padding-bottom: 11px;
        }
    }
    .page-bottom{
        margin-top: 10px;
    }
    .btn-confirm{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        font-size: 14px;
        color:#fff;
        position: fixed;
        bottom:20px;
        left:50%;
        transform: translateX(-50%);
        @media screen and (max-width:750px){
            border-radius: 26px;
        }
    }
}
</style>